import all from './all';
import store from './store';
import bulkStore from './bulkStore';
import destroy from './destroy';
import update from './update';

export default {
  all,
  store,
  bulkStore,
  destroy,
  update,
};



// WEBPACK FOOTER //
// ./src/app/services/creditNoteProduct/index.js